import Browser from '@mindful-web/marko-web/browser';
import Shared from '@bobit-business-media/package-global/browser';

Shared(Browser);

export default Browser;
